<template>
  <!-- <div
    class="personal-leave-content"
    :class="{'personal-leave-content-full' : dataRemaining.filter(item => item.id != employeeId).length == 0}"
  > -->
  <div v-if="(checkChild.child_total != 0) || ['ROLE_ADMIN,', 'ROLE_ADMIN', 'ROLE_ADMIN_HRD', 'ROLE_ADMIN_HRD,', 'ROLE_MANAGEMENT'].includes(userRole)" class="personal-leave-content">
    <div v-if="employeeShow" class="personal-content">
      <!-- Profile content -->
      <div v-if="dataPersonal" class="profile-content">
        <div class="profile-content-image">
          <img :src="dataPersonal.img64 ? dataPersonal.img64 : defaultImage">
        </div>

        <div class="profile-content-detail">
          <table>
            <tr>
              <td>Name</td>
              <td>:</td>
              <td>{{ dataPersonal.name ? dataPersonal.name : userName ? userName : '' }}</td>
            </tr>

            <tr>
              <td>EIN</td>
              <td>:</td>
              <td>{{ dataPersonal.ein ? dataPersonal.ein : '' }}</td>
            </tr>

            <tr>
              <td>Work Unit</td>
              <td>:</td>
              <td>{{ dataPersonal.satker_name ? dataPersonal.satker_name : '' }}</td>
            </tr>

            <tr>
              <td>Position</td>
              <td>:</td>
              <td>{{ dataPersonal.position_name ? dataPersonal.position_name : '' }}</td>
            </tr>

            <tr>
              <td>E-mail</td>
              <td>:</td>
              <td>{{ dataPersonal.email ? dataPersonal.email : '' }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div v-if="(dataHistory.length != 0)" class="current-content">
        <div class="current-header">
          <p>Remaining Leave Balance</p>
        </div>

        <div class="current-table">
          <table>
            <tr v-for="leave in dataHistory" :key="leave">
              <td>-</td>
              <td>{{ leave.leave_name }}</td>
              <td>:</td>
              <td>Balance: <b>{{ leave.sisa_cuti }}</b> ({{ leave.period }})</td>
            </tr>
          </table>
        </div>

        <!-- <div>
          <div class="history-tab" @click="openDetail('open', dataHistory)">All Details</div>
        </div> -->

        <div v-if="!isLoading && (dataHistory.length != 0)" class="show-content">
          <div @click="openDetail('open', dataPersonal, dataHistory)" class="show-button">
            <p>Show All</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!employeeShow" class="personal-content">
      <div class="check-content">
        <p>Please select employee first to view profile and leave!</p>
      </div>
    </div>

    <!-- History leave content -->
    <div v-if="!isLoading && (dataLeave.length != 0)" class="history-content">
      <div class="history-header">
        <p>Leave History</p>
      </div>

      <div class="history-notes">
        <p>Notes:</p>
        <p>Draft</p>
        <p>Waiting for Approval</p>
        <p>Approved</p>
        <p>Rejected / Expired</p>
      </div>

      <div class="history-tabs">
        <div class="history-tab" :class="{'history-tab-active' : (isShowAll == 0)}" @click="isShowAll = 0">Annual Leave</div>
        <div class="history-tab" :class="{'history-tab-active' : (isShowAll == 1)}" @click="isShowAll = 1">Show All</div>
        <!-- <div class="history-tab" @click="openDetail('open', dataPersonal, dataAnnual)">All Details</div> -->
      </div>

      <div v-if="isShowAll == 0" class="history-table">
        <ag-grid-vue
          style="width: 100%; height: 500px;"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnAnnual"
          :pagination="true"
          :context="context"
          @grid-ready="onGridReady"
          :rowData="dataAnnual">
        </ag-grid-vue>
      </div>

      <div v-if="isShowAll == 1" class="history-table">
        <ag-grid-vue
          style="width: 100%; height: 500px;"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnAll"
          :pagination="true"
          :context="context"
          @grid-ready="onGridReady"
          :rowData="dataLeave">
        </ag-grid-vue>
      </div>

        <!-- <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Remarks</th>
              <th>Days</th>
              <th v-if="isShowAll == 0">Balance</th>
              <th>Approved / Rejected by</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="data in filteredData" :key="data"
              :class="{
                'state1' : (data.state == 'Draft'),
                'state2' : (data.state == 'Waiting for Approval'),
                'state3' : (data.state == 'Approved'),
                'state4' : (data.state == 'Rejected' || data.state == 'Expired')
              }"
            >
              <td v-html="formatDate(data.transaction_date)" />
              <td v-html="data.leave_name" />
              <td v-html="data.qty" class="text-right" />
              <td v-if="isShowAll == 0" v-html="data.balance" class="text-right" />
              <td v-html="data.updated_by" />
            </tr>
          </tbody>
        </table> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, onMounted, onBeforeMount, computed, watch, watchEffect, reactive } from 'vue'
  import { useRouter } from 'vue-router'
  import axios from 'axios'

  import defaultImage from '@/assets/general/usericon.png'

  import { AgGridVue } from 'ag-grid-vue3'
  import ButtonStatusLeave from '../../../components/ButtonStatusLeave.vue'

  export default {
    components: {
      AgGridVue,
      ButtonStatusLeave
    },

    props: {
      isLoading: { type: Boolean, default: false },
      dataPersonal: { type: Object, default: {} },
      dataHistory: { type: Object, default: [] },
      dataRemaining: { type: Object, default: [] },
      dataLeave: { type: Object, default: [] },
      dataAnnual: { type: Object, default: [] },
      employeeShow: { type: Boolean, default: false },
      checkChild: { type: Object, default: {} }
    },

    beforeMount () {
      this.context = {
        componentParent: this
      }
    },

    methods: {
      onGridReady (params) {
        this.gridApi = params.api
        this.gridColumnApi = params.columnApi
        const allColumnIds = []
        this.gridColumnApi.getAllColumns().forEach((column) => {
            allColumnIds.push(column.colId)
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, false)
      }
    },

    setup (props, { emit }) {
      const userRole = localStorage.getItem('roles')
      const userName = localStorage.getItem('name')
      const userEmail = localStorage.getItem('Email')
      const employeeId = localStorage.getItem('employee_id')

      const isShowAll = ref(0)
      const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true
      }
      const columnAnnual = [
        { headerName: '#', valueGetter: 'node.rowIndex+1' },
        { field: 'transaction_date', headerName: 'Date', minWidth: 120 },
        { field: 'leave_name', headerName: 'Remarks', minWidth: 200 },
        { field: 'qty', headerName: 'Used', minWidth: 120 },
        { field: 'balance', headerName: 'Balance', minWidth: 120 },
        { field: 'state', headerName: 'Status', cellRendererFramework: 'ButtonStatusLeave', minWidth: 200 },
        { field: 'updated_by', headerName: 'Approved/Rejected By', minWidth: 120 }
        // { headerName: t('department.manager'), sortable: true, filter: true, cellRenderer: (data) => {
        //     if (data.data.manager_name !== null){
        //         const wali1 = '<b>'+data.data.manager_ein+'</b> - '+data.data.manager_name+'<br />'
        //     return wali1
        //     } else {
        //         return ''
        //     }
        // }},
        // { field: 'description', headerName: t('vaccines.description'), sortable: true, filter: true },
        // { field: 'id', headerName: t('class.isActive'), sortable: true, filter: true, cellRendererFramework: 'ButtonActive' },
        // { field: 'id', headerName: t('main.action'), sortable: true, filter: true, minWidth: 165, cellRendererFramework: 'ButtonActionRender' }
      ]
      const columnAll = [
        { headerName: '#', valueGetter: 'node.rowIndex+1' },
        { field: 'transaction_date', headerName: 'Date', minWidth: 120 },
        { field: 'leave_name', headerName: 'Remarks', minWidth: 200 },
        { field: 'qty', headerName: 'Used', minWidth: 120 },
        // { field: 'balance', headerName: 'Balance', minWidth: 120 },
        { field: 'state', headerName: 'Status', cellRendererFramework: 'ButtonStatusLeave', minWidth: 200 },
        { field: 'updated_by', headerName: 'Approved/Rejected By', minWidth: 120 }
        // { field: 'name', headerName: t('department.title'), sortable: true, filter: true },
        // { headerName: t('department.manager'), sortable: true, filter: true, cellRenderer: (data) => {
        //     if (data.data.manager_name !== null){
        //         const wali1 = '<b>'+data.data.manager_ein+'</b> - '+data.data.manager_name+'<br />'
        //     return wali1
        //     } else {
        //         return ''
        //     }
        // }},
        // { field: 'description', headerName: t('vaccines.description'), sortable: true, filter: true },
        // { field: 'id', headerName: t('class.isActive'), sortable: true, filter: true, cellRendererFramework: 'ButtonActive' },
        // { field: 'id', headerName: t('main.action'), sortable: true, filter: true, minWidth: 165, cellRendererFramework: 'ButtonActionRender' }
      ]

      const yearNow = ref('')
      const getDate = () => {
        const thisDate = new Date()
        yearNow.value = thisDate.getFullYear()
      }

      const shortMonthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Agu", "Sep", "Oct", "Nov", "Dec"]
      function formatDate(date) {
        const day = new Date(date).getDate()
        const month = new Date(date).getMonth()
        const year = new Date(date).getFullYear()
        const dayOfWeek = new Date(date).getDay()

        // const months = locale.value == 'id' ? shortMonthsId : shortMonthsEn
        // const days = locale.value == 'id' ? daysId : daysEn

        const formattedDate = `${day} ${shortMonthsEn[month]} ${year}`
        return formattedDate
      }

      onMounted(() => {
        getDate()
      })

      // watchEffect(() => {
      //   if(props.dataHistory) {
      //     console.log("cek leave history", props.dataHistory)
      //   }
      // })


      const openRemaining = (type, data) => {
        const prevData = {
          group: type,
          id: data,
          data: data
        }

        emit('open-remaining', prevData)
      }

      const filteredData = ref([])
      watch(() => [isShowAll.value, props.dataAnnual], ([newVal, newLev], [oldval, oldLev]) => {
        if(isShowAll.value > 0){
          filteredData.value = props.dataAnnual
        }
        else {
          filteredData.value = props.dataAnnual.filter(function (item) { return item.type === 'Annual Leave' })
        }
        // console.log('filteredData.value', filteredData.value)
      })



    function formatList(data) {
      // console.log("cek format data",data)
      const groupedData = {}

      data.forEach(item => {
        const dateObj = new Date(item.period)
        const year = dateObj.getFullYear().toString()
        const monthIndex = dateObj.getMonth()

        // console.log("cek format year",year)

        if (!groupedData[year]) {
          groupedData[year] = {
            data: [],
            index: year
          }
        }
        // console.log("cek pre year",  groupedData[year])

        groupedData[year].data.push(item)
      })

      return groupedData
    }


      const openDetail = (type, profile, data) => {
        // console.log("cek detail", type, profile, data)
        const baseData = profile
        baseData['list_leave'] = formatList(data)

        emit('open-remaining', baseData)


        // console.log("cek detail final", baseData)
      }


      return {
        isShowAll,
        defaultColDef,
        columnAnnual,
        columnAll,
        filteredData,
        defaultImage,
        userRole,
        userName,
        userEmail,
        employeeId,
        yearNow,
        formatDate,
        openRemaining,
        openDetail
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-show-true {
    background-color: #007C2B;
    color: white;
  }
  .is-show-false {
    background-color: #DFFFEA;
    color: black;
  }

  .personal-leave-content {
    display: flex;
    flex-direction: column;
    gap: 20px;


    .personal-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .profile-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: start;
        gap: 20px;

        .profile-content-image {
          width: 100%;
          height: fit-content;
          display: flex;
          justify-content: center;

          img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
          }
        }

        .profile-content-detail {
          width: 100%;
          height: fit-content;

          table {
            width: 100%;
            height: auto;

            tr {
              td {
                padding: 0;
                font-size: 14px;
                line-height: 24px;
                word-spacing: 1px;
                cursor: default;
                vertical-align: top;

                &:nth-child(1) {
                  width: 80px;
                }

                &:nth-child(2) {
                  width: 10px;
                }

                &:nth-child(3) {
                  width: calc(100% - 80px - 10px);
                  font-weight: 500;
                }
              }

              &:hover {
                td {
                  background-color: transparent;
                }
              }
            }
          }
        }
      }

      .current-content {
        width: 100%;

        .current-header {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          border-top: 1px solid lightgray;
          padding: 0 8px;

          p {
            font-size: 16px;
            line-height: 24px;
            font-weight: 600;
            color: black;
          }
        }

        .current-table {
          width: 100%;

          table {
            tr {
              td {
                font-size: 14px;
                line-height: 24px;
                padding: 0;
                vertical-align: top;

                &:nth-child(2) {
                  width: calc(100% - 10px - 10px - 120px);
                }

                &:nth-child(1), &:nth-child(3) {
                  width: 10px;
                }

                &:nth-child(4) {
                  width: 120px;

                  b {
                    font-weight: 600 !important;
                  }
                }
              }
            }
          }
        }

        .show-content {
          width: 100%;
          // height: 60px;
          // padding: 16px 12px 0 12px;
          display: flex;
          // justify-content: center;
          margin-top: 16px;

          .show-button {
            width: max-content;
            height: 36px;
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: center;
            padding: 0 20px;
            cursor: pointer;
            border-radius: 12px;
            background-color: rgb(43, 110, 255);
            border: 2px solid rgb(0, 81, 255);

            p {
              color: white;
              width: 100%;
              text-align: center;
              font-size: 12px;
              line-height: 18px;
              font-weight: 500;
              position: relative;
              z-index: 5;
            }

            @media (min-width: 480px) {
              &::before {
                content: '';
                width: 0%;
                height: 0%;
                border-radius: 100%;
                position: absolute;
                z-index: 1;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: rgba(255, 255, 255, 0.15);
                transition: width .4s, height .4s, border-radius .4s;
              }

              &:hover {
                &::before {
                  width: 200%;
                  height: 200%;
                  border-radius: 0;
                }
              }
            }
          }
        }
      }

      .check-content {
        width: 100%;
        height: 428px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 16px;
        padding: 20px;
        background-color: rgb(235, 235, 235);

        p {
          width: 100%;
          text-align: center;
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
        }
      }
    }

    .history-content {
      width: 100%;

      .history-header {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        border-top: 1px solid lightgray;
        padding: 0 4px;

        p {
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          color: black;
        }
      }

      .history-tabs {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        padding: 0 4px;

        .history-tab {
          width: max-content;
          height: 32px;
          padding: 0 16px;
          display: flex;
          align-items: center;
          background-color: #DFFFEA;
          color: black;
          transition: background-color .5s, color .5s;
          cursor: pointer;
          text-align: center;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
        }
        .history-tab-active {
          background-color: #007C2B;
          color: white;
        }
      }

      .history-notes {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 8px 4px 16px 4px;

        p {
          width: max-content;
          height: auto;
          font-size: 12px;
          line-height: 20px;
          font-weight: 500;

          &:nth-child(2) {
            font-weight: 700;
            color: rgb(0, 85, 255);
          }
          &:nth-child(3) {
            font-weight: 700;
            color: rgb(235, 172, 0);
          }
          &:nth-child(4) {
            font-weight: 700;
            color: green;
          }
          &:nth-child(5) {
            font-weight: 700;
            color: red;
          }
        }
      }

      .history-table {
        width: 100%;
        height: auto;
        overflow-y: auto;
        border: 1px solid lightgray;
        border-radius: 8px;

        table, thead, tbody, tr, th, td {
          border-collapse: collapse;
        }

        table {
          width: 100%;
          height: max-content;

          tr {
            th, td {
              font-size: 12px;
              line-height: 20px;
              padding: 0;
            }
          }

          thead {
            position: sticky;
            top: 0;

            tr {
              th {
                font-weight: 600;
                padding: 6px 8px;
                background-image: linear-gradient(to bottom, navy, rgb(2, 2, 186));
                color: white;
                text-align: center;
              }
            }
          }

          tbody {
            tr {
              td {
                padding: 4px 8px;
                border: 1px solid lightgray;
                cursor: pointer;

                &:nth-child(1) {
                  border-left: none;
                }

                &:nth-last-child(1) {
                  border-right: none;
                }
              }
            }
          }
        }
      }
    }

    @media (min-width: 1024px) {
      .personal-content {
        .profile-content {
          flex-direction: row;

          .profile-content-image {
            width: 120px;
          }

          .profile-content-detail {
            width: calc(100% - 120px - 20px);

            table {
              tr {
                td {
                  &:nth-child(1) {
                    width: 160px;
                  }

                  &:nth-child(3) {
                    width: calc(100% - 160px - 10px);
                    font-weight: 500;
                  }
                }
              }
            }
          }
        }

        .current-content {
          .current-table {
            table {
              tr {
                td {
                  &:nth-child(2) {
                    width: 200px;
                  }

                  &:nth-child(4) {
                    width: calc(100% - 10px - 10px - 200px);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .personal-leave-content-full {
    @media (min-width: 1024px) {
      flex-direction: row;
      align-items: start;

      .personal-content {
        width: 50%;
      }

      .history-content {
        width: 50%;

        .history-header {
          border-top: none;
        }
      }
    }
  }
</style>
